/* PPFC cart drawer — Subscribe & Save toggle.
   Delegated listeners (survive the drawer's re-render). Applies/removes each
   line item's selling plan, then asks the theme to re-render the drawer. */
(function () {
  if (window.__ppfcCartSub) return;
  window.__ppfcCartSub = true;
  var busy = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function syncEmptyClass() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var el = document.querySelector('cart-drawer');
        if (el) el.classList.toggle('wt-cart--empty', c.item_count === 0);
      })
      .catch(function () {});
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
    syncEmptyClass();
  }

  // Bridge: our custom PDP / bundle add-to-cart fires the theme's generic
  // "cart:refresh"; the native drawer only re-renders on "cart-drawer:refresh".
  document.addEventListener('cart:refresh', function () { refresh(); });

  async function subscribe(map) {
    for (var i = 0; i < map.length; i++) {
      try { await post('/cart/change.js', { id: map[i].key, selling_plan: map[i].plan }); } catch (e) {}
    }
    refresh();
  }

  async function onetime() {
    try {
      var cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (it.selling_plan_allocation) {
          try { await post('/cart/change.js', { id: it.key, selling_plan: null }); } catch (e) {}
        }
      }
    } catch (e) {}
    refresh();
  }

  async function addVariant(id) {
    try { await post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }); } catch (e) {}
    refresh();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var done = function () { busy = false; };

    var add = e.target.closest('[data-ppfc-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      if (busy) return;
      busy = true;
      add.classList.add('is-loading');
      addVariant(add.getAttribute('data-ppfc-add')).then(done, done);
      return;
    }

    var btn = e.target.closest('[data-ppfc-sub]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;
    btn.classList.add('is-loading');
    var action = btn.getAttribute('data-ppfc-sub');
    if (action === 'subscribe') {
      var el = document.querySelector('[data-ppfc-submap]');
      var map = [];
      try { map = JSON.parse(el.textContent); } catch (e) {}
      subscribe(map).then(done, done);
    } else {
      onetime().then(done, done);
    }
  });
})();
